import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { landingAPI } from 'api/landingAPI';
import produce from 'immer';

export const fetchTopRanks = createAsyncThunk(
    'landing/fetchTopRanks',
    async (params) => await landingAPI.fetchTopRanks(params)
);

export const fetchTopAndEmergingSpikes = createAsyncThunk(
    'landing/fetchTopAndEmergingSpikes',
    async (params) => await landingAPI.fetchTopAndEmergingSpikes(params)
);

export const fetchLandingPageStats = createAsyncThunk(
    'landing/fetchLandingPageStats',
    async (params) => await landingAPI.fetchLandingPageStats(params)
);

const landingSlice = createSlice({
    name: 'landing',
    initialState: {
        topThreeMarketsData: null,
        topFiveTeamsData: null,
        topFiveRmsData: null,
        topFiveEmergingMajorRm: null,
        topFiveEmergingModerateRm: null,
        topFiveRmsSpike: null,
        minorThreshold: null,
        majorThreshold: null,
        stats: null,
        topMarketsTeamsRmsFetched: false,
        topAndEmergingSpikesFetched: false,
        statsFetched: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTopRanks.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { topThreeMarkets, topFiveTeams, topFiveRm } = payload;
                draft.topThreeMarketsData = topThreeMarkets;
                draft.topFiveTeamsData = topFiveTeams;
                draft.topFiveRmsData = topFiveRm;
                draft.topMarketsTeamsRmsFetched = true;

                if (topFiveRm.length > 0) {
                    const { moderateThreshold, majorThreshold } = topFiveRm[0];
                    draft.minorThreshold = moderateThreshold;
                    draft.majorThreshold = majorThreshold;
                }
            })
        );
        builder.addCase(
            fetchTopAndEmergingSpikes.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const {
                        topFiveEmergingMajorRm,
                        topFiveEmergingModerateRm,
                        topFiveRmSpike
                    } = payload;
                    const emergingRmsToRetrieveThreshold = () => {
                        if (topFiveRmSpike.length > 0) return topFiveRmSpike;
                        if (topFiveEmergingModerateRm.length > 0)
                            return topFiveEmergingModerateRm;
                        if (topFiveEmergingMajorRm.length > 0)
                            return topFiveEmergingMajorRm;
                        return [];
                    };
                    if (emergingRmsToRetrieveThreshold().length > 0) {
                        const { moderateThreshold, majorThreshold } =
                            emergingRmsToRetrieveThreshold()[0];
                        draft.minorThreshold = moderateThreshold;
                        draft.majorThreshold = majorThreshold;
                    }
                    draft.topFiveEmergingMajorRm = topFiveEmergingMajorRm;
                    draft.topFiveEmergingModerateRm = topFiveEmergingModerateRm;
                    draft.topFiveRmsSpike = topFiveRmSpike;
                    draft.topAndEmergingSpikesFetched = true;
                })
        );
        builder.addCase(fetchLandingPageStats.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { statsReporting } = payload;
                draft.stats = statsReporting;
                draft.statsFetched = true;
            })
        );
    }
});

const { reducer: landingReducer } = landingSlice;
export default landingReducer;
